module.exports = __webpack_public_path__ + "img/symbol_6.50e63b75.png";